import * as brand from "./brand";
import * as category from "./category";
import * as expCenter from "./expCenter";
import * as home from "./home";
import * as friendLink from "./friendLink";
import * as msg from "./msg";
import * as product from "./product";

export default {
  brand,
  expCenter,
  home,
  category,
  friendLink,
  msg,
  product
};
